export const initTableOfContents = (): void => {
  const tocContainers = document.querySelectorAll<HTMLElement>(
    "[data-toc-container]",
  );
  if (tocContainers.length === 0) return;

  const contentAreas = document.querySelectorAll<HTMLElement>(
    ".post-content-wysiwyg",
  );
  if (contentAreas.length === 0) return;

  // 1. Sayfadaki Başlıkları Topla
  const headings: HTMLElement[] = [];
  contentAreas.forEach((area) => {
    const found = area.querySelectorAll<HTMLElement>("h2, h3, h4");
    found.forEach((h) => headings.push(h));
  });

  if (headings.length === 0) {
    tocContainers.forEach((c) => (c.style.display = "none"));
    return;
  }

  // 2. İçindekiler Kutusunu Doldur ve Etkileşimleri Kur
  tocContainers.forEach((tocContainer) => {
    const list =
      tocContainer.querySelector<HTMLUListElement>("[data-toc-list]");
    const toggleBtn =
      tocContainer.querySelector<HTMLButtonElement>("[data-toc-toggle]");
    if (!list) return;

    headings.forEach((heading, index) => {
      // Başlığa benzersiz ID ata
      if (!heading.id) {
        let slug = heading.textContent
          ?.trim()
          .toLowerCase()
          .replace(/[^a-z0-9ğüşöçı]/g, "-")
          .replace(/-+/g, "-")
          .replace(/^-|-$/g, "");

        if (!slug) slug = `heading`;
        heading.id = `${slug}-${index}`;
      }

      const li = document.createElement("li");
      li.className = `post-content-toc__item post-content-toc__item--${heading.tagName.toLowerCase()}`;

      const a = document.createElement("a");
      a.href = `#${heading.id}`;
      a.className = "post-content-toc__link";
      a.textContent = heading.textContent;

      // Kaydırma (Smooth Scroll) Aksiyonu
      a.addEventListener("click", (e) => {
        e.preventDefault();
        const target = document.getElementById(heading.id);
        if (target) {
          const offset = 100; // Sticky header mesafesi
          const top =
            target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top, behavior: "smooth" });
        }
      });

      li.appendChild(a);
      list.appendChild(li);
    });

    // 3. Akordeon (Aç/Kapa) Olayı
    if (toggleBtn) {
      toggleBtn.addEventListener("click", () => {
        const isOpen = tocContainer.classList.toggle("is-open");
        toggleBtn.setAttribute("aria-expanded", String(isOpen));
      });
    }
  });

  console.log("[TOC] Initialized Table of Contents with Accordion.");
};
